/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpRegistriesGetServerDetails } from "../funcs/mcpRegistriesGetServerDetails.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ExternalMCPServer } from "../models/components/externalmcpserver.js";
import {
  GetMCPServerDetailsRequest,
  GetMCPServerDetailsSecurity,
} from "../models/operations/getmcpserverdetails.js";
import { unwrapAsync } from "../types/fp.js";
export type McpRegistriesGetServerDetailsQueryData = ExternalMCPServer;

export function prefetchMcpRegistriesGetServerDetails(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMCPServerDetailsRequest,
  security?: GetMCPServerDetailsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMcpRegistriesGetServerDetailsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMcpRegistriesGetServerDetailsQuery(
  client$: GramCore,
  request: GetMCPServerDetailsRequest,
  security?: GetMCPServerDetailsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<McpRegistriesGetServerDetailsQueryData>;
} {
  return {
    queryKey: queryKeyMcpRegistriesGetServerDetails({
      registryId: request.registryId,
      serverSpecifier: request.serverSpecifier,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function mcpRegistriesGetServerDetailsQueryFn(
      ctx,
    ): Promise<McpRegistriesGetServerDetailsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpRegistriesGetServerDetails(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMcpRegistriesGetServerDetails(
  parameters: {
    registryId: string;
    serverSpecifier: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpRegistries", "getServerDetails", parameters];
}
